<ng-container
  *ngrxLet="{
    theme: theme$,
  } as vm">
  @if (navList === null) {
    <app-progress-spinner></app-progress-spinner>
  } @else {
    <mat-toolbar class="flex justify-between" role="banner">
      <div class="flex align-center gap-8">
        @if (patient && !isWideScreen) {
          <app-icon-button icon="menu" (click)="onOpenMenu()" color="on-primary" ariaLabel="Open Menu">
          </app-icon-button>
        }
        <button type="button" class="logo-btn" (click)="goHome()" aria-label="Go to home page">
          <img
            id="imgLogo"
            src="images/logo-white-small.svg"
            alt="Marietta Memorial Hospital Logo"
            aria-hidden="true" />
        </button>
      </div>
      <div class="flex gap-15 align-center">
        @if (patient) {
          @if (patient.patientPictureImageUrl) {
            <button
              type="button"
              class="circle-image cursor"
              [matMenuTriggerFor]="userMenu"
              aria-label="User menu"
              [appInsightsEvent]="{ name: 'App.UserMenu.Clicked', dims: { feature: 'app' } }">
              <img id="imgProfile" [src]="patient.patientPictureImageUrl" alt="Placeholder profile" />
            </button>
          } @else {
            <button
              type="button"
              class="circle-initials cursor"
              [matMenuTriggerFor]="userMenu"
              aria-label="User menu"
              [appInsightsEvent]="{ name: 'App.UserMenu.Clicked', dims: { feature: 'app' } }">
              @for (p of [patient]; track p.patientId) {
                <span>{{ p.firstName[0] }}{{ p.lastName[0] }}</span>
              }
            </button>
          }
          <mat-menu #userMenu="matMenu">
            @for (userPatient of user?.userPatients; track userPatient) {
              <button
                mat-menu-item
                class="justify-center"
                [ngClass]="{ selected: isSelectedPatient(userPatient.patientId) }"
                (click)="changePatient(userPatient.patientId)">
                <div class="flex align-center gap-12">
                  @if (userPatient.patientPictureImageUrl) {
                    <img [src]="userPatient.patientPictureImageUrl" alt="Patient Picture" class="menu-image" />
                  } @else {
                    <span class="menu-initials">{{ userPatient.firstName[0] }}{{ userPatient.lastName[0] }}</span>
                  }
                  <span>{{ userPatient.firstName }}</span>
                </div>
              </button>
            }
            <mat-divider class="mt-0"></mat-divider>
            <button mat-menu-item type="button" role="menuitemcheckbox" [attr.aria-checked]="vm.theme === 'dark'">
              <div class="flex align-center gap-12">
                <app-icon name="dark_mode" color="on-surface" class="mr-0" aria-hidden="true"></app-icon>
                <div class="flex gap-4 align-center">
                  <span class="fw-500">Dark Mode</span>
                  <mat-slide-toggle
                    [ngModel]="vm.theme === 'dark'"
                    [tabIndex]="-1"
                    class="theme-toggle"
                    aria-hidden="true"
                    (change)="setTheme($event)"
                    (click)="$event.stopPropagation()">
                  </mat-slide-toggle>
                </div>
              </div>
            </button>
            <button mat-menu-item (click)="notificationSettings()">
              <div class="flex gap-12 align-center">
                <app-icon name="settings" class="mr-0" color="on-surface"></app-icon>
                <span>Notification Settings</span>
              </div>
            </button>
            <button mat-menu-item (click)="personalInformation()">
              <div class="flex gap-12 align-center">
                <app-icon name="article_person" class="mr-0" color="on-surface"></app-icon>
                <span>Personal Information</span>
              </div>
            </button>
            @if (canRequestProxyAccess) {
              <button mat-menu-item (click)="requestProxyAccess()">
                <div class="flex gap-12 align-center">
                  <app-icon name="approval_delegation" class="mr-0" color="on-surface"></app-icon>
                  <span>Request Proxy Access</span>
                </div>
              </button>
            }
            <button mat-menu-item (click)="giveFeedback()">
              <div class="flex gap-12 align-center">
                <app-icon name="feedback" class="mr-0" color="on-surface"></app-icon>
                <span>Give Feedback</span>
              </div>
            </button>
            <button mat-menu-item class="menu-btn" (click)="logout()">
              <div class="flex gap-12 align-center">
                <app-icon name="logout" class="mr-0" color="on-surface"></app-icon>
                <span>Logout</span>
              </div>
            </button>
          </mat-menu>
        }
      </div>
    </mat-toolbar>
  }
</ng-container>
